import { Box, Button, Typography } from '@mui/material';
import { STRINGS } from '../../../constants';
import { SummaryDetails } from '../../../components/SummaryDetails';
import { CitysprintTextLogo } from './CitysprintTextLogo';
import { CitysprintSummaryQuoteDetails } from './CitysprintSummaryQuoteDetails';

export function CitysprintCompleteBookingSummary({
  booking,
  onBack,
  onNext,
  primaryLabel = STRINGS.NEXT_STEP,
  footerCaption,
  nextDisabled = false,
  nextPending = false,
  nextError = '',
}) {
  const ex = parseFloat(booking.priceExcl);
  const inc = parseFloat(booking.priceIncl);
  const vatAmount = !Number.isNaN(ex) && !Number.isNaN(inc) ? inc - ex : null;

  const price = {
    totalIncVatAmount: !Number.isNaN(inc) ? inc : 0,
    taxAmount: vatAmount ?? 0,
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: t => `calc(var(--dpd-appbar-height, 0px) + ${t.spacing(2)})`,
      }}
    >
      <Box
        sx={{
          pl: { xs: 3, md: 0 },
          pr: { xs: 3, md: 0 },
        }}
      >
        <SummaryDetails
          price={price}
          basketItemsWithPrice={[]}
          displayItemsPriceDetails={false}
          displayInsurance={false}
          belowSummaryContent={<CitysprintTextLogo />}
          itemsContent={<CitysprintSummaryQuoteDetails quote={booking} />}
        />

        <Box
          sx={{
            gap: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            pb: 2,
          }}
        >
          <Button
            variant='outlined'
            type='button'
            onClick={onBack}
            sx={{ flexGrow: 1, marginLeft: { xs: 2, md: 0 } }}
          >
            {STRINGS.BACK}
          </Button>
          <Button
            variant='contained'
            type='button'
            onClick={onNext}
            disabled={nextDisabled || nextPending}
            sx={{
              flexGrow: 1,
              marginRight: { xs: 2, md: 0 },
            }}
          >
            {nextPending ? 'Loading…' : primaryLabel}
          </Button>
        </Box>
        {nextError ? (
          <Typography
            variant='caption'
            color='error'
            sx={{ mt: 1, display: 'block' }}
          >
            {nextError}
          </Typography>
        ) : null}
        {footerCaption && !nextError ? (
          <Typography
            variant='caption'
            color='text.secondary'
            sx={{ mt: 1, display: 'block' }}
          >
            {footerCaption}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}
